import React from 'react';
import { Box, Typography } from '@mui/material';
import {
  SHOWCASE_SCAN_CTA,
  SHOWCASE_SCAN_PDF_PATH,
  SHOWCASE_VERIFY_FOOTER_AFTER,
  SHOWCASE_VERIFY_FOOTER_BADGE,
  SHOWCASE_VERIFY_FOOTER_BEFORE,
  SHOWCASE_VERIFY_FOOTER_CONTROL,
  SHOWCASE_VERIFY_FOOTER_NOTE,
  SHOWCASE_VERIFY_FOOTER_REDUCTION,
} from '../../domain/showcase/showcaseScanExample';

/** One compact footer under the warehouse cards. Not a second condition panel. */
export function ShowcaseVerifyFooter() {
  return (
    <Box
      data-testid="showcase-verify-footer"
      sx={{
        gridColumn: '1 / -1',
        mt: 0.25,
        pt: 0.75,
        borderTop: '1px solid rgba(255,255,255,0.10)',
      }}
    >
      <Typography data-testid="showcase-verify-footer-badge" sx={{ fontWeight: 800, fontSize: 13, letterSpacing: 0.4, color: '#9fb0c8', lineHeight: 1.2 }}>
        {SHOWCASE_VERIFY_FOOTER_BADGE}
      </Typography>
      <Typography data-testid="showcase-verify-footer-note" sx={{ fontWeight: 650, fontSize: 13, color: '#9fb0c8', lineHeight: 1.25, mt: 0.15 }}>
        {SHOWCASE_VERIFY_FOOTER_NOTE}
      </Typography>
      <Typography data-testid="showcase-verify-control-summary" sx={{ fontWeight: 750, fontSize: 15, lineHeight: 1.3, mt: 0.2 }}>
        {SHOWCASE_VERIFY_FOOTER_BEFORE}
        {'  →  '}
        {SHOWCASE_VERIFY_FOOTER_CONTROL}
        {'  →  '}
        {SHOWCASE_VERIFY_FOOTER_AFTER}
      </Typography>
      <Typography data-testid="showcase-verify-footer-reduction" sx={{ fontWeight: 800, fontSize: 14, lineHeight: 1.25, mt: 0.15 }}>
        {SHOWCASE_VERIFY_FOOTER_REDUCTION}
      </Typography>
      <Box
        component="a"
        data-testid="showcase-scan-link"
        href={SHOWCASE_SCAN_PDF_PATH}
        target="_blank"
        rel="noopener noreferrer"
        sx={{ display: 'inline-block', mt: 0.35, color: '#60a5fa', fontWeight: 700, fontSize: 14, textDecoration: 'none' }}
      >
        {SHOWCASE_SCAN_CTA}
      </Box>
    </Box>
  );
}
